export const teamAssetKey = name => String(name || '').trim().toLowerCase();

/** Existing team media aliases shared by selection and Dashboard presentation. */
export function buildTeamCrestMap(teams) {
  const crests = {};
  for (const team of teams) {
    if (!team.logo_url) continue;
    for (const name of [team.official_name, team.display_name, team.footystats_name]) {
      if (teamAssetKey(name)) crests[teamAssetKey(name)] = team.logo_url;
    }
  }
  return crests;
}

// Presentation fallbacks for existing repository-supported club names. These
// are explicit codes, never inferred from prefixes or initials. Stored code wins.
const teamCodes = new Map([
  ['tottenham hotspur','TOT'],['tottenham','TOT'],['spurs','TOT'],
  ['manchester city','MCI'],['liverpool','LIV'],
  ['brighton & hove albion','BHA'],['brighton and hove albion','BHA'],['brighton','BHA'],
  ['wolverhampton wanderers','WOL'],['wolves','WOL'],['nottingham forest','NFO'],
]);
const aliases = team => [...new Set([team.official_name,team.display_name,team.footystats_name].map(teamAssetKey).filter(Boolean))];

export function buildTeamPresentationIndex(teams) {
  const byId=new Map(),byAlias=new Map();
  for(const team of teams) {
    if(team.id)byId.set(team.id,team);
    for(const alias of aliases(team)) {
      // Ambiguous aliases must not arbitrarily borrow another club's identity.
      if(byAlias.has(alias)&&byAlias.get(alias)!==team)byAlias.set(alias,null);
      else byAlias.set(alias,team);
    }
  }
  return {byId,byAlias};
}

export function resolveTeamPresentation({name,teamId},index) {
  const team=(teamId&&index?.byId.get(teamId))||index?.byAlias.get(teamAssetKey(name));
  const ambiguous=!team&&index?.byAlias.has(teamAssetKey(name))&&index.byAlias.get(teamAssetKey(name))===null;
  const storedCode=typeof team?.code==='string'?team.code.trim():'';
  const mappedCodes=[...new Set((ambiguous?[]:team?aliases(team):[teamAssetKey(name)]).map(alias=>teamCodes.get(alias)).filter(Boolean))];
  const fallback=mappedCodes.length===1?mappedCodes[0]:null;
  return {id:team?.id??null,crest:team?.logo_url||null,
    label:storedCode||fallback||'—',source:storedCode?'teams.code':fallback?'presentation mapping':'unavailable'};
}

export function resolveFixtureTeamPresentation({fixtureId,team},fixtures,index) {
  const fixture=fixtures?.find(f=>f.id===fixtureId);
  const teamId=fixture?.home_team===team?fixture.home_team_id:fixture?.away_team===team?fixture.away_team_id:null;
  return resolveTeamPresentation({name:team,teamId},index);
}
